import { useMemo, useState, useEffect } from "react";
import { Modal, Tabs } from "antd";
import UserItem from "../UserItem";

const ReactionsModal = ({ onCancel, reactions = [], users = [] }) => {
  const [activeTab, setActiveTab] = useState("all");

  useEffect(() => {
    setActiveTab("all");
  }, []);

  const usersMap = useMemo(() => {
    return Object.fromEntries(users.map((u) => [u.id, u]));
  }, [users]);

  const { filteredReactions, tabItems } = useMemo(() => {
    const grouped = reactions.reduce((acc, { emoji, ...rest }) => {
      (acc[emoji] ||= []).push({ emoji, ...rest });
      return acc;
    }, {});

    const filteredReactions =
      activeTab === "all" ? reactions : (grouped[activeTab] ?? []);

    const tabItems = [
      {
        key: "all",
        label: `All ${reactions.length}`,
      },
      ...Object.entries(grouped).map(([emoji, arr]) => ({
        key: emoji,
        label: `${emoji} ${arr.length}`,
      })),
    ];

    return { filteredReactions, tabItems };
  }, [reactions, activeTab]);

  return (
    <Modal
      open
      onCancel={onCancel}
      footer={null}
      title={null}
      styles={{ body: { padding: 0 } }}
    >
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={tabItems}
        className="reactions-tabs"
      />
      <div className="flex-col">
        {filteredReactions.map((reaction) => (
          <UserItem user={usersMap[reaction?.sender_id || reaction?.user_id]}>
            <span style={{ fontSize: "25px" }}>{reaction.emoji}</span>
          </UserItem>
        ))}
      </div>
    </Modal>
  );
};

export default ReactionsModal;
